/**
 * 国际化系统
 */
export class I18n {
  constructor(defaultLang = 'zh') {
    this.lang = defaultLang;
    this.translations = {
      common: {
        zh: {
          // 通用翻译
          'app.name': '儿童游戏乐园',
          'app.tagline': '适合3-8岁儿童的益智游戏',
          'btn.back': '返回',
          'btn.start': '开始',
          'btn.restart': '重新开始',
          'btn.close': '关闭',
          'btn.playAgain': '再玩一次',
          'btn.next': '下一关',
          'difficulty.easy': '简单',
          'difficulty.medium': '中等',
          'difficulty.hard': '困难',
          'score': '得分',
          'time': '时间',
          'moves': '步数',
          'congrats': '太棒了！',
          'completed': '你完成了游戏！',
          'loading': '加载中...',
          'error.load': '加载失败，请重试',
          'category.puzzle': '拼图',
          'category.memory': '记忆',
          'category.math': '数学',
          'category.reflex': '反应',
          'category.creative': '创意'
        },
        en: {
          'app.name': 'Kids Game Land',
          'app.tagline': 'Educational games for ages 3-8',
          'btn.back': 'Back',
          'btn.start': 'Start',
          'btn.restart': 'Restart',
          'btn.close': 'Close',
          'btn.playAgain': 'Play Again',
          'btn.next': 'Next',
          'difficulty.easy': 'Easy',
          'difficulty.medium': 'Medium',
          'difficulty.hard': 'Hard',
          'score': 'Score',
          'time': 'Time',
          'moves': 'Moves',
          'congrats': 'Great Job!',
          'completed': 'You completed the game!',
          'loading': 'Loading...',
          'error.load': 'Failed to load, please try again',
          'category.puzzle': 'Puzzle',
          'category.memory': 'Memory',
          'category.math': 'Math',
          'category.reflex': 'Reflex',
          'category.creative': 'Creative'
        }
      }
    };
  }
  
  /**
   * 加载翻译
   * @param {string} namespace - 命名空间（游戏ID或'common'）
   * @param {object} translations - 翻译对象 { zh: {...}, en: {...} }
   */
  load(namespace, translations) {
    this.translations[namespace] = translations;
  }
  
  /**
   * 切换语言
   * @param {string} lang - 'zh' | 'en'
   */
  setLanguage(lang) {
    if (this.translations.common[lang]) {
      this.lang = lang;
      localStorage.setItem('app-lang', lang);
      this.notifyListeners();
    }
  }
  
  /**
   * 获取当前语言
   * @returns {string}
   */
  getLanguage() {
    return this.lang;
  }
  
  /**
   * 翻译
   * @param {string} key - 翻译键，支持嵌套如 'btn.start'
   * @param {string} namespace - 命名空间
   * @param {object} params - 插值参数
   * @returns {string}
   */
  t(key, namespace = 'common', params = {}) {
    const ns = this.translations[namespace];
    if (!ns) return key;
    
    const translations = ns[this.lang] || ns.zh;
    let text = translations[key];
    
    if (!text) {
      // 尝试从 common 获取
      if (namespace !== 'common') {
        return this.t(key, 'common', params);
      }
      return key;
    }
    
    // 插值替换
    if (params) {
      Object.keys(params).forEach(k => {
        text = text.replace(new RegExp(`{{${k}}}`, 'g'), params[k]);
      });
    }
    
    return text;
  }
  
  /**
   * 检测浏览器语言
   * @returns {string}
   */
  detectLanguage() {
    const saved = localStorage.getItem('app-lang');
    if (saved && this.translations.common[saved]) {
      return saved;
    }
    const browser = navigator.language.slice(0, 2);
    return this.translations.common[browser] ? browser : 'zh';
  }
  
  /**
   * 初始化（检测并设置语言）
   */
  init() {
    this.lang = this.detectLanguage();
  }
  
  /**
   * 添加语言切换监听器
   * @param {Function} callback
   */
  onChange(callback) {
    if (!this._listeners) this._listeners = [];
    this._listeners.push(callback);
  }
  
  /**
   * 通知监听器
   */
  notifyListeners() {
    if (this._listeners) {
      this._listeners.forEach(cb => cb(this.lang));
    }
  }
  
  /**
   * 获取支持的语言列表
   * @returns {Array}
   */
  getSupportedLanguages() {
    return ['zh', 'en'];
  }
}

// 单例导出
export const i18n = new I18n();
